<script>
import { MountingPortal } from 'portal-vue';
import Const from '../../Const';

export default {
    functional: true,
    render(h, { scopedSlots }) {
        let selector = `#${Const.PORTAL_TARGET_NAME_POPUP}`;
        const el = document.querySelector(selector);
        if (el == null) {
            // fallback to body if target not found (this normally wont happen, but we also need to gen docs)
            // vue-styleguidist is not aware of this container, so we fallback to body
            selector = 'body';
        }
        const children = scopedSlots.default ? scopedSlots.default({}) : [];

        return h(
            MountingPortal,
            {
                props: {
                    mountTo: selector,
                    append: true,
                    bail: false,
                    multiple: true
                }
            },
            children
        );
    }
};
</script>
